import { create } from 'apisauce';
import toast from 'react-hot-toast';

// API Configuration
// const API_BASE_URL = 'http://127.0.0.1:8000/api/v1';
// const API_BASE_URL = 'http://carsandbids-api.test/api/v1';
const API_BASE_URL = 'http://noorapi.queeninstyle.in/api/v1';
console.log('API_BASE_URL', localStorage.getItem('user'));
// Create apisauce instance
const api = create({
	baseURL: API_BASE_URL,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
		'Authorization': `Bearer ${localStorage.getItem('user')?.token}`
	},
});

console.log("🚀 API instance created with baseURL:", API_BASE_URL);

// Add auth token to requests if available
api.addRequestTransform((request) => {
	console.log("🔍 Request Transform Called:", request.url, request.method);
	console.log("🔍 Request headers before:", request.headers);
	
	const userStr = localStorage.getItem('user');
	console.log("🔍 Raw user string from localStorage:", userStr);
	
	if (userStr) {
		try {
			const user = JSON.parse(userStr);
			console.log("🔍 Parsed user object:", user);
			
			if (!request.headers) request.headers = {};
			if (user && user.token) {
				request.headers['Authorization'] = `Bearer ${user.token}`;
				console.log('🔐 Adding Bearer token to request:', request.url, 'Token:', user.token.substring(0, 20) + '...');
				console.log('🔍 Request headers after:', request.headers);
			} else {
				console.log('⚠️ No token found for request:', request.url);
				console.log('⚠️ User object:', user);
			}
		} catch (error) {
			console.error('Error parsing user from localStorage:', error);
			localStorage.removeItem('user');
		}
	} else {
		console.log('⚠️ No user data in localStorage for request:', request.url);
	}
});

console.log("✅ Request transform registered successfully");

// Test function to verify API instance is working
export const testApi = () => {
	console.log("🧪 Testing API instance...");
	console.log("API baseURL:", API_BASE_URL);
	console.log("API instance:", api);
	return api.get('/test-endpoint');
};

// Test function to check localStorage
export const testLocalStorage = () => {
	console.log("🧪 Testing localStorage...");
	const user = localStorage.getItem('user');
	console.log("Raw user data:", user);
	if (user) {
		try {
			const parsed = JSON.parse(user);
			console.log("Parsed user data:", parsed);
			console.log("Token:", parsed.token);
		} catch (e) {
			console.error("Error parsing user data:", e);
		}
	}
};

// Test function to manually test request transform
export const testRequestTransform = async () => {
	console.log("🧪 Testing request transform manually...");
	
	// Get user from localStorage
	const userStr = localStorage.getItem('user');
	console.log("User from localStorage:", userStr);
	
	if (userStr) {
		try {
			const user = JSON.parse(userStr);
			console.log("Parsed user:", user);
			
			if (user && user.token) {
				// Manually create a request object to test transform
				const request = {
					url: '/test-endpoint',
					method: 'GET',
					headers: {}
				};
				
				console.log("Request before transform:", request);
				
				// Simulate what the transform does
				request.headers['Authorization'] = `Bearer ${user.token}`;
				
				console.log("Request after manual transform:", request);
				console.log("Authorization header:", request.headers['Authorization']);
			} else {
				console.log("No token found in user object");
			}
		} catch (e) {
			console.error("Error in manual test:", e);
		}
	} else {
		console.log("No user data in localStorage");
	}
};

// Add response transform for error handling
api.addResponseTransform((response) => {
	if (response.status === 401) {
		// Handle unauthorized access
		console.warn('🚨 401 Unauthorized - Token may be invalid or expired');
		localStorage.removeItem('user');
    const currentPath = window.location.pathname;
    // Avoid hard redirect from protected pages where we want to handle gracefully
    if (currentPath !== '/awb-master' && currentPath !== '/listings') {
      window.location.href = '/login';
    }
	}
});

// Helper function to check if error is network-related
const isNetworkError = (error) => {
	return (
		error.problem === 'NETWORK_ERROR' ||
		error.problem === 'TIMEOUT_ERROR' ||
		error.problem === 'CONNECTION_ERROR' ||
		!navigator.onLine
	);
};

// Helper function to show appropriate error message
const getErrorMessage = (error) => {
	if (isNetworkError(error)) {
		return 'No internet connection. Please check your network and try again.';
	}

	const response = error?.response || error;
	const status = response?.status;
	const data = response?.data;
	const originalError = error?.originalError || response?.originalError;

	if (status === 413) {
		return (typeof data === 'string' && data.trim()) || data?.message || 'Uploaded data is too large. Please reduce the file size and try again.';
	}

	if (data) {
		if (typeof data === 'string') {
			return data;
		}

		if (Array.isArray(data)) {
			return data.filter(Boolean).join(', ');
		}

		if (data.message) {
			return data.message;
		}

		if (data.error) {
			return data.error;
		}

		if (data.errors) {
			if (Array.isArray(data.errors)) {
				return data.errors.filter(Boolean).join(', ');
			}

			if (typeof data.errors === 'object') {
				const errors = Object.values(data.errors).flat().filter(Boolean);
				if (errors.length) {
					return errors.join(', ');
				}
			}
		}
	}

	if (originalError?.message) {
		return originalError.message;
	}

	return error?.message || 'An error occurred';
};

// Generic API methods
export const apiService = {
	// GET request
	get: async (endpoint, params = {}) => {
		console.log("🌐 ApiService.get called:", endpoint, params);
		try {
			// Check if online before making request
			if (!navigator.onLine) {
				throw new Error('No internet connection');
			}

			// Manually add token if not already added
			const userStr = localStorage.getItem('user');
			if (userStr) {
				try {
					const user = JSON.parse(userStr);
					if (user && user.token) {
						console.log("🔐 Manually adding token to request:", endpoint);
						api.setHeader('Authorization', `Bearer ${user.token}`);
					}
				} catch (e) {
					console.error("Error adding token manually:", e);
				}
			}

			const response = await api.get(endpoint, params);
			if (response.ok) {
				return response.data;
			} else {
				console.error('API GET Error:', response.problem);
				const errorMessage = getErrorMessage(response);
				throw new Error(errorMessage);
			}
		} catch (error) {
			console.error('API GET Error:', error);
			const errorMessage = getErrorMessage(error);
			throw new Error(errorMessage);
		}
	},

	// POST request
	post: async (endpoint, data = {}) => {
		try {
			// Check if online before making request
			if (!navigator.onLine) {
				throw new Error('No internet connection');
			}

			const response = await api.post(endpoint, data);
			if (response.ok) {
				return response.data;
			} else {
				console.error('API POST Error:', response.problem);
				const errorMessage = getErrorMessage(response);
				throw new Error(errorMessage);
			}
		} catch (error) {
			console.error('API POST Error:', error);
			const errorMessage = getErrorMessage(error);
			throw new Error(errorMessage);
		}
	},

	// PUT request
	put: async (endpoint, data = {}) => {
		try {
			// Check if online before making request
			if (!navigator.onLine) {
				throw new Error('No internet connection');
			}

			const response = await api.put(endpoint, data);
			if (response.ok) {
				return response.data;
			} else {
				console.error('API PUT Error:', response.problem);
				const errorMessage = getErrorMessage(response);
				throw new Error(errorMessage);
			}
		} catch (error) {
			console.error('API PUT Error:', error);
			const errorMessage = getErrorMessage(error);
			throw new Error(errorMessage);
		}
	},

	// DELETE request
	delete: async (endpoint) => {
		try {
			// Check if online before making request
			if (!navigator.onLine) {
				throw new Error('No internet connection');
			}

			const response = await api.delete(endpoint);
			if (response.ok) {
				return response.data;
			} else {
				console.error('API DELETE Error:', response.problem);
				const errorMessage = getErrorMessage(response);
				throw new Error(errorMessage);
			}
		} catch (error) {
			console.error('API DELETE Error:', error);
			const errorMessage = getErrorMessage(error);
			throw new Error(errorMessage);
		}
	},

	// PATCH request
	patch: async (endpoint, data = {}) => {
		try {
			if (!navigator.onLine) {
				throw new Error('No internet connection');
			}
			const response = await api.patch(endpoint, data);
			if (response.ok) {
				return response.data;
			}
			console.error('API PATCH Error:', response.problem);
			const errorMessage = getErrorMessage(response);
			throw new Error(errorMessage);
		} catch (error) {
			console.error('API PATCH Error:', error);
			const errorMessage = getErrorMessage(error);
			throw new Error(errorMessage);
		}
	},
};

// Master API services
export const roleService = {
	getAll: (params) => apiService.get('/roles', params),
	getById: (id) => apiService.get(`/roles/${id}`),
	create: (data) => apiService.post('/roles', data),
	update: (id, data) => apiService.put(`/roles/${id}`, data),
	delete: (id) => apiService.delete(`/roles/${id}`),
};

export const sizeService = {
	getAll: (params) => apiService.get('/sizes', params),
	getById: (id) => apiService.get(`/sizes/${id}`),
	create: (data) => apiService.post('/sizes', data),
	update: (id, data) => apiService.put(`/sizes/${id}`, data),
	delete: (id) => apiService.delete(`/sizes/${id}`),
};

export const colorService = {
	getAll: (params) => apiService.get('/colors', params),
	getById: (id) => apiService.get(`/colors/${id}`),
	create: (data) => apiService.post('/colors', data),
	update: (id, data) => apiService.put(`/colors/${id}`, data),
	delete: (id) => apiService.delete(`/colors/${id}`),
};

export const categoryService = {
	getAll: (params) => apiService.get('/categories', params),
	getById: (id) => apiService.get(`/categories/${id}`),
	create: (data) => apiService.post('/categories', data),
	update: (id, data) => apiService.put(`/categories/${id}`, data),
	delete: (id) => apiService.delete(`/categories/${id}`),
};

export const menuService = {
	getAll: (params) => apiService.get('/menus', params),
	getById: (id) => apiService.get(`/menus/${id}`),
	create: (data) => apiService.post('/menus', data),
	update: (id, data) => apiService.put(`/menus/${id}`, data),
	delete: (id) => apiService.delete(`/menus/${id}`),
};

export const branchService = {
	getAll: (params) => apiService.get('/branches', params),
	getById: (id) => apiService.get(`/branches/${id}`),
	create: (data) => apiService.post('/branches', data),
	update: (id, data) => apiService.put(`/branches/${id}`, data),
	delete: (id) => apiService.delete(`/branches/${id}`),
};

export const userService = {
	getAll: (params) => apiService.get('/users', params),
	getById: (id) => apiService.get(`/users/${id}`),
	create: (data) => apiService.post('/users', data),
	update: (id, data) => apiService.put(`/users/${id}`, data),
	delete: (id) => apiService.delete(`/users/${id}`),
	toggleStatus: (id) => apiService.patch(`/users/${id}/toggle-status`, {}),
	assignBranches: (id, data) => apiService.post(`/users/${id}/assign-branches`, data),
};

export const brandService = {
	getAll: (params) => apiService.get('/brands', params),
	getById: (id) => apiService.get(`/brands/${id}`),
	create: (data) => apiService.post('/brands', data),
	update: (id, data) => apiService.put(`/brands/${id}`, data),
	delete: (id) => apiService.delete(`/brands/${id}`),
	toggleStatus: (id) => apiService.patch(`/brands/${id}/toggle-status`, {}),
};

export const simpleCategoryService = {
	getAll: (params) => apiService.get('/simple-categories', params),
	getById: (id) => apiService.get(`/simple-categories/${id}`),
	create: (data) => apiService.post('/simple-categories', data),
	update: (id, data) => apiService.put(`/simple-categories/${id}`, data),
	delete: (id) => apiService.delete(`/simple-categories/${id}`),
	toggleStatus: (id) => apiService.patch(`/simple-categories/${id}/toggle-status`, {}),
	reorder: (orders) => apiService.post('/simple-categories/reorder', { orders }),
};

export const genderMasterService = {
	getAll: (params) => apiService.get('/gender-masters', params),
	getById: (id) => apiService.get(`/gender-masters/${id}`),
	create: (data) => apiService.post('/gender-masters', data),
	update: (id, data) => apiService.put(`/gender-masters/${id}`, data),
	delete: (id) => apiService.delete(`/gender-masters/${id}`),
	toggleStatus: (id) => apiService.patch(`/gender-masters/${id}/toggle-status`, {}),
	reorder: (orders) => apiService.post('/gender-masters/reorder', { orders }),
};

export const fabricService = {
	getAll: (params) => apiService.get('/fabrics', params),
	getById: (id) => apiService.get(`/fabrics/${id}`),
	create: (data) => apiService.post('/fabrics', data),
	update: (id, data) => apiService.put(`/fabrics/${id}`, data),
	delete: (id) => apiService.delete(`/fabrics/${id}`),
	toggleStatus: (id) => apiService.patch(`/fabrics/${id}/toggle-status`, {}),
};

export const workService = {
	getAll: (params) => apiService.get('/works', params),
	getById: (id) => apiService.get(`/works/${id}`),
	create: (data) => apiService.post('/works', data),
	update: (id, data) => apiService.put(`/works/${id}`, data),
	delete: (id) => apiService.delete(`/works/${id}`),
	toggleStatus: (id) => apiService.patch(`/works/${id}/toggle-status`, {}),
};

export const timesWornService = {
	getAll: (params) => apiService.get('/times-worn', params),
	getById: (id) => apiService.get(`/times-worn/${id}`),
	create: (data) => apiService.post('/times-worn', data),
	update: (id, data) => apiService.put(`/times-worn/${id}`, data),
	delete: (id) => apiService.delete(`/times-worn/${id}`),
	toggleStatus: (id) => apiService.patch(`/times-worn/${id}/toggle-status`, {}),
};

export const conditionGradeService = {
	getAll: (params) => apiService.get('/condition-grades', params),
	getById: (id) => apiService.get(`/condition-grades/${id}`),
	create: (data) => apiService.post('/condition-grades', data),
	update: (id, data) => apiService.put(`/condition-grades/${id}`, data),
	delete: (id) => apiService.delete(`/condition-grades/${id}`),
	toggleStatus: (id) => apiService.patch(`/condition-grades/${id}/toggle-status`, {}),
};

export const defectService = {
	getAll: (params) => apiService.get('/defects', params),
	getById: (id) => apiService.get(`/defects/${id}`),
	create: (data) => apiService.post('/defects', data),
	update: (id, data) => apiService.put(`/defects/${id}`, data),
	delete: (id) => apiService.delete(`/defects/${id}`),
	toggleStatus: (id) => apiService.patch(`/defects/${id}/toggle-status`, {}),
};

export const customerReviewService = {
	getAll: (params) => apiService.get('/customer-reviews', params),
	getById: (id) => apiService.get(`/customer-reviews/${id}`),
	create: (data) => apiService.post('/customer-reviews', data),
	update: (id, data) => apiService.put(`/customer-reviews/${id}`, data),
	delete: (id) => apiService.delete(`/customer-reviews/${id}`),
	toggleStatus: (id) => apiService.patch(`/customer-reviews/${id}/toggle-status`, {}),
};

// Content Policy services (Super Admin only)
export const contentPolicyService = {
	getAll: () => apiService.get('/content-policies'),
	getByType: (type) => apiService.get(`/content-policies/${type}`),
	create: (data) => apiService.post('/content-policies', data),
	update: (type, data) => apiService.put(`/content-policies/${type}`, data),
	delete: (type) => apiService.delete(`/content-policies/${type}`),
};

// Listing Remarks services
export const listingRemarksService = {
	getAll: (listingId) => apiService.get('/listing-remarks', { listing_id: listingId }),
	getById: (id) => apiService.get(`/listing-remarks/${id}`),
	create: (data) => apiService.post('/listing-remarks', data),
	update: (id, data) => apiService.put(`/listing-remarks/${id}`, data),
	delete: (id) => apiService.delete(`/listing-remarks/${id}`),
};

// Stock services
export const stockService = {
	available: (params) => apiService.get('/stock/available', params),
	review: (data) => apiService.post('/stock/review', data),
};

// AWB services
export const awbService = {
  list: (params) => apiService.get('/awb', params),
  createRange: (data) => apiService.post('/awb/range', data),
};

// Admin Listings services
export const listingsService = {
  // Get all listings with filters and pagination
  getAll: (params) => {
    console.log("📋 ListingsService.getAll called with:", params);
    // return apiService.get('/admin/listings/grouped-by-status', params);
    return apiService.get('/admin/listings', params);
  },
  
  // Get listings grouped by status
  getGroupedByStatus: (params) => apiService.get('/admin/listings/grouped-by-status', params),
  
  // Get single listing details
  getById: (listingId) => apiService.get(`/admin/listings/${listingId}`),
  
  // Update listing details
  update: (listingId, data) => apiService.put(`/admin/listings/${listingId}`, data),
  
  // Update listing status
  updateStatus: (listingId, data) => apiService.patch(`/admin/listings/${listingId}/status`, data),
  
  // Update dress status
  updateDressStatus: (listingId, data) => apiService.patch(`/admin/listings/${listingId}/dress-status`, data),
  
  // De-list a listing (remove from active listings)
  delistListing: (listingId) => {
    console.log("🗑️ De-listing listing:", listingId);
    return apiService.post(`/admin/listings/${listingId}/delist`);
  },
  
  // Get listing statistics
  getStatistics: () => apiService.get('/admin/listings-statistics'),
  
  // Apply redactions to an image
  applyImageRedactions: (imageId, redactions) => {
    console.log("🖼️ Applying redactions to image:", imageId, redactions);
    return apiService.post('/admin/images/apply-redactions', {
      image_id: imageId,
      redactions: redactions
    });
  },
  
  // Toggle featured status of a listing
  toggleFeatured: (listingId) => {
    console.log("⭐ Toggling featured status for listing:", listingId);
    return apiService.post(`/admin/listings/${listingId}/toggle-featured`);
  },

  // Mark rejected listing as returned to seller with AWB details
  returnToSeller: (listingId, data) => {
    console.log("📦 Marking listing return to seller:", listingId, data);
    return apiService.post(`/admin/listings/${listingId}/return-to-seller`, data);
  },
  
  // Assign or update branch for a listing
  assignBranch: (listingId, branchId) => {
    console.log("🏪 Assigning branch to listing:", listingId, branchId);
    return apiService.post(`/admin/listings/${listingId}/assign-branch`, { branch_id: branchId });
  },
};

export const dressStatusService = {
  // Get all dress statuses
  getAll: () => apiService.get('/admin/dress-statuses'),
};

// Dashboard service
export const dashboardService = {
  // Get dashboard statistics based on user role
  getStatistics: () => apiService.get('/dashboard/statistics'),
  // Get pending listings and purchases without AWB
  getPriorityItems: () => apiService.get('/dashboard/priority-items'),
};

// Upcoming Deliveries service
export const upcomingDeliveriesService = {
  // Get all upcoming deliveries (in-transit items)
  getAll: () => apiService.get('/website-users/in-transit-items'),
  
  // Mark item as received by store
  markReceived: (orderId, data) => apiService.post(`/admin/purchases/${orderId}/received`, data),
};

// Branch Manager Listings service
export const branchListingsService = {
  // Get all listings for branch managers (received items)
  getAll: (params) => {
    console.log("🏪 BranchListingsService.getAll called with:", params);
    return apiService.get('/admin/listings', params);
  },
  
  // Get single listing details
  getById: (listingId) => apiService.get(`/admin/listings/${listingId}`),
  
  // Update listing status (for branch managers)
  updateStatus: (listingId, data) => apiService.patch(`/admin/listings/${listingId}/status`, data),
};

// Offers service
export const offersService = {
  // Get all offers for a listing
  getByListingId: (listingId) => {
    console.log("💰 OffersService.getByListingId called for:", listingId);
    return apiService.get(`/listings/${listingId}/offers`);
  },
  
  // Get the last/highest offer for a listing
  getLastOffer: (listingId) => {
    console.log("💰 OffersService.getLastOffer called for:", listingId);
    return apiService.get(`/listings/${listingId}/offers/last`);
  },
  
  // Accept offer (seller only)
  acceptOffer: (offerId) => {
    console.log("💰 OffersService.acceptOffer called for:", offerId);
    return apiService.post(`/offers/${offerId}/accept`);
  },
  
  // Reject offer (seller only)
  rejectOffer: (offerId) => {
    console.log("💰 OffersService.rejectOffer called for:", offerId);
    return apiService.post(`/offers/${offerId}/reject`);
  },
  
  // Update offer status (accept/reject)
  updateStatus: (offerId, data) => {
    console.log("💰 OffersService.updateStatus called for:", offerId, data);
    return apiService.patch(`/offers/${offerId}/status`, data);
  },
};

// Admin Purchase services
export const purchaseService = {
  // Get all purchases with filters
  getAll: (params) => apiService.get('/admin/purchases', params),
  
  // Get orders ready to ship (both payments done, not yet shipped)
  getReadyToShip: () => apiService.get('/purchases/ready-to-ship'),
  
  // Get single purchase details
  getById: (orderId) => apiService.get(`/admin/purchases/${orderId}`),
  
  // Get branch stock items (items with dress_status_id = 4 - At Store)
  getBranchStock: (params) => apiService.get('/admin/purchases/branch-stock', params),
  
  // Assign AWB number to purchase (automatically finds next available AWB)
  assignAwb: (orderId) => apiService.post(`/admin/purchases/${orderId}/assign-awb`),
  
  // Dispatch to buyer - Manual AWB assignment by Store Manager
  dispatchToBuyer: (orderId, data) => apiService.post(`/admin/purchases/${orderId}/dispatch-to-buyer`, data),
  
        // Send AWB number to seller via email
        sendAwbToSeller: (orderId) => apiService.post(`/admin/purchases/${orderId}/send-awb-email`),
        
        // Mark item as received at store
        markItemReceived: (orderId) => apiService.post(`/admin/purchases/${orderId}/received`),
  
  // Authenticate item
  authenticateItem: (orderId, data) => apiService.post(`/admin/purchases/${orderId}/authenticate`, data),
  
  // Submit detailed authentication review for a listing
  submitAuthenticationReview: (data) => apiService.post('/admin/purchases/authenticate-review', data),
  
  // Process refund
  refund: (orderId, data) => apiService.post(`/admin/purchases/${orderId}/refund`, data),
};

// Authentication services
export const authService = {
	login: async (credentials) => {
		console.log("🔐 AuthService.login called with:", credentials);
		try {
			const response = await api.post('/auth/login', credentials);
			console.log("🔐 AuthService API response:", response);
			if (response.ok && response.data.success) {
				// Return the data structure as received from API
				return { success: true, data: response.data.data };
			} else {
				throw new Error(response.data?.message || 'Login failed');
			}
		} catch (error) {
			console.error('Login error:', error);
			throw error;
		}
	},

	logout: async () => {
		try {
			await api.post('/auth/logout');
			localStorage.removeItem('user');
			return { success: true };
		} catch (error) {
			// Even if API call fails, clear local storage
			localStorage.removeItem('user');
			console.error('Logout error:', error);
			return { success: true };
		}
	},

	me: async () => {
		try {
			const response = await api.get('/auth/me');
			if (response.ok && response.data.success) {
				return response.data.data.user;
			} else {
				throw new Error('Failed to get user info');
			}
		} catch (error) {
			console.error('Get user info error:', error);
			throw error;
		}
	},

	register: async (userData) => {
		try {
			const response = await api.post('/auth/register', userData);
			if (response.ok && response.data.success) {
				// Store user data and token
				const user = {
					...response.data.data.user,
					token: response.data.data.token
				};
				localStorage.setItem('user', JSON.stringify(user));
				return { success: true, data: user };
			} else {
				throw new Error(response.data?.message || 'Registration failed');
			}
		} catch (error) {
			console.error('Registration error:', error);
			throw error;
		}
	}
};

// Utility functions for token management
export const tokenUtils = {
	// Get current token from localStorage
	getToken: () => {
		try {
			const userStr = localStorage.getItem('user');
			if (userStr) {
				const user = JSON.parse(userStr);
				return user.token || null;
			}
			return null;
		} catch (error) {
			console.error('Error getting token:', error);
			return null;
		}
	},

	// Check if user is authenticated
	isAuthenticated: () => {
		return tokenUtils.getToken() !== null;
	},

	// Get current user data
	getCurrentUser: () => {
		try {
			const userStr = localStorage.getItem('user');
			if (userStr) {
				return JSON.parse(userStr);
			}
			return null;
		} catch (error) {
			console.error('Error getting user data:', error);
			return null;
		}
	},

	// Clear authentication data
	clearAuth: () => {
		localStorage.removeItem('user');
	},

	// Set authentication data
	setAuth: (userData) => {
		localStorage.setItem('user', JSON.stringify(userData));
	}
};

// Utility function to show toast messages
export const showToast = {
	success: (message) => toast.success(message),
	error: (message) => toast.error(message),
	loading: (message) => toast.loading(message),
};
